import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowUpRight, History, Home, Mic2, User, Users } from 'lucide-react';
import './Footerbar.css';
import { getActiveRoomId, onActiveRoomChanged } from '../lib/activeRoomSession';

export default function Footerbar() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeRoomId, setActiveRoomId] = useState(() => getActiveRoomId());
    const isActive = (path) => location.pathname.startsWith(path);
    const go = (path) => navigate(path);

    useEffect(() => onActiveRoomChanged(() => setActiveRoomId(getActiveRoomId())), []);

    return (
        <>
            {activeRoomId && (
                <button
                    className="app-room-presence"
                    type="button"
                    onClick={() => go(`/manage-room/${activeRoomId}`)}
                    aria-label="Conectado à sala. Abrir sala"
                >
                    <span className="app-room-presence__dot" />
                    <span>Conectado à sala</span>
                    <ArrowUpRight size={17} aria-hidden="true" />
                </button>
            )}
            <nav className="app-bottom-nav" aria-label="Navegação principal">
                <button className={`app-bottom-nav__item ${isActive('/home') ? 'is-active' : ''}`} aria-current={isActive('/home') ? 'page' : undefined} onClick={() => go('/home')}>
                    <Home size={20} /><span>Início</span>
                </button>
                <button className={`app-bottom-nav__item ${isActive('/history') ? 'is-active' : ''}`} aria-current={isActive('/history') ? 'page' : undefined} onClick={() => go('/history')}>
                    <History size={20} /><span>Histórico</span>
                </button>
                <button className={`app-bottom-nav__item ${isActive('/shows') ? 'is-active' : ''}`} aria-current={isActive('/shows') ? 'page' : undefined} onClick={() => go('/shows')}>
                    <Mic2 size={20} /><span>Shows</span>
                </button>
                <button className={`app-bottom-nav__item ${isActive('/manage-room') ? 'is-active' : ''}`} aria-current={isActive('/manage-room') ? 'page' : undefined} onClick={() => go('/manage-room')}>
                    <Users size={20} /><span>Salas</span>
                </button>
                <button className={`app-bottom-nav__item ${isActive('/profile') ? 'is-active' : ''}`} aria-current={isActive('/profile') ? 'page' : undefined} onClick={() => go('/profile')}>
                    <User size={20} /><span>Perfil</span>
                </button>
            </nav>
        </>
    );
}
